// Shared by the desktop home, mobile home, header and navigation.
export const currentEvent = "diwali";
